import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_data-line",
  "use": "icon-project_data-line-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_data-line\"><g transform=\"translate(0 3)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><rect x=\"1\" y=\"1\" width=\"26\" height=\"20\" rx=\"4\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 14l6.632-4.611 5.684 2.305L23 7\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol